import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PricesResolver } from "./services/resolvers/prices.resolver";
import { Step1Component } from "./pages/step1/step1.component";
import { Step2Component } from "./pages/step2/step2.component";
import { Step3Component } from "./pages/step3/step3.component";
import { Step4Component } from "./pages/step4/step4.component";
import { Step5Component } from "./pages/step5/step5.component";
import { Step2Guard } from "./pages/step2/step2.guard";
import { Step3Guard } from "./pages/step3/step3.guard";
import { Step4Guard } from "./pages/step4/step4.guard";
import { Step5Guard } from "./pages/step5/step5.guard";

import {
    PATH_STEP_1,
    PATH_STEP_2,
    PATH_STEP_3,
    PATH_STEP_4,
    PATH_STEP_5,
} from "./app-routing.constants";

const routes: Routes = [
    {
        path: "",
        redirectTo: PATH_STEP_1,
        pathMatch: "full",
        resolve: { prices: PricesResolver },
    },
    {
        path: PATH_STEP_1,
        component: Step1Component,
        resolve: { prices: PricesResolver },
    },
    {
        path: PATH_STEP_2,
        component: Step2Component,
        canActivate: [Step2Guard],
        resolve: { prices: PricesResolver },
    },
    {
        path: PATH_STEP_3,
        component: Step3Component,
        canActivate: [Step3Guard],
        resolve: { prices: PricesResolver },
    },
    {
        path: PATH_STEP_4,
        component: Step4Component,
        canActivate: [Step4Guard],
        resolve: { prices: PricesResolver },
    },
    {
        path: PATH_STEP_5,
        component: Step5Component,
        canActivate: [Step5Guard],
        resolve: { prices: PricesResolver },
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule],
    providers: [Step2Guard, Step3Guard, Step4Guard, Step5Guard],
})
export class AppRoutingModule {
    //
}
